import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, Grid, Card, CardMedia, CardContent, Button, Dialog, DialogActions, DialogContent, DialogTitle, Input, Snackbar } from '@mui/material';
import axios from 'axios';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Alert from '@mui/material/Alert';
import KnowOurSchoolSection from './OurSchoolSection';
import './CarouselCustom.css'; // Importando o arquivo CSS personalizado
import ResultsSection from './ResultsSection';
import LocationsSection from './LocationSection';

const Campaigns = () => {
  const placeholderImage = 'https://via.placeholder.com/400x200'; // Imagem padrão

  const [highlightPhotos, setHighlightPhotos] = useState(() => {
    const savedPhotos = localStorage.getItem('highlightPhotos');
    return savedPhotos ? JSON.parse(savedPhotos) : Array(2).fill(placeholderImage);
  });

  const [galleryPhotos, setGalleryPhotos] = useState(() => {
    const savedPhotos = localStorage.getItem('galleryPhotos');
    return savedPhotos ? JSON.parse(savedPhotos) : Array(3).fill(placeholderImage);
  });

  const [dialogOpen, setDialogOpen] = useState(false);
  const [currentSelection, setCurrentSelection] = useState(null);
  const [currentType, setCurrentType] = useState(null);
  const [dialogImages, setDialogImages] = useState([]);
  const [uploadFile, setUploadFile] = useState(null);
  const [uploadError, setUploadError] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [userType, setUserType] = useState(null); // Estado para o tipo de usuário
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const fetchImages = async (endpoint) => {
    try {
      const response = await axios.get(`${baseUrl}/uploads/images/${endpoint}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      });
      console.log(`Resposta da API de ${endpoint}:`, response.data);

      if (Array.isArray(response.data)) {
        return response.data.filter(image => image.url); // Simples filtro para URLs válidas
      } else {
        console.error(`Resposta da API ${endpoint} não é uma array:`, response.data);
        return [];
      }
    } catch (error) {
      console.error(`Erro ao buscar as imagens de ${endpoint}:`, error);
      return [];
    }
  };

  useEffect(() => {
    const fetchAllImages = async () => {
      const [highlightImages, galleryImages] = await Promise.all([
        fetchImages('highlight'),
        fetchImages('gallery')
      ]);

      console.log('Imagens de destaque filtradas:', highlightImages);
      console.log('Imagens de galeria filtradas:', galleryImages);

      setHighlightPhotos(highlightImages.length > 0 ? highlightImages.map(image => image.url) : Array(2).fill(placeholderImage));
      setGalleryPhotos(galleryImages.length > 0 ? galleryImages.map(image => image.url) : Array(3).fill(placeholderImage));
    };

    fetchAllImages();

    // Fetch user type (example: from localStorage or API)
    const fetchUserType = async () => {
      // Simulação de uma chamada à API ou recuperação de dados do localStorage
      const savedUser = localStorage.getItem('user');
      const { usertype } = savedUser ? JSON.parse(savedUser) : {};
      setUserType(usertype); // Defina um valor padrão se o userType não estiver disponível
    };

    fetchUserType();
  }, [baseUrl]);

  const fetchDialogImages = async (type) => {
    const images = await fetchImages(type);
    console.log('Imagens no modal:', images);
    return images;
  };

  const openDialog = async (index, type) => {
    setCurrentSelection(index);
    setCurrentType(type);
    const images = await fetchDialogImages(type);
    setDialogImages(images);
    setDialogOpen(true);
  };

  const handleSelectPhoto = (url) => {
    if (currentType === 'highlight') {
      const newPhotos = [...highlightPhotos];
      newPhotos[currentSelection] = url;
      setHighlightPhotos(newPhotos);
      localStorage.setItem('highlightPhotos', JSON.stringify(newPhotos));
    } else if (currentType === 'gallery') {
      const newPhotos = [...galleryPhotos];
      newPhotos[currentSelection] = url;
      setGalleryPhotos(newPhotos);
      localStorage.setItem('galleryPhotos', JSON.stringify(newPhotos));
    }
    setDialogOpen(false);
  };

  const handleUpload = async () => {
    if (!uploadFile) {
      setUploadError('Nenhum arquivo selecionado.');
      return;
    }

    const formData = new FormData();
    formData.append('file', uploadFile);

    try {
      // Envio do arquivo para a API
      await axios.post(`${baseUrl}/uploads/images/${currentType}`, formData, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      setUploadError('');
      setSnackbarOpen(true);

      // Atualização da lista de imagens no modal
      const updatedImages = await fetchDialogImages(currentType);
      setDialogImages(updatedImages);

      // Atualização da lista de imagens da galeria
      const updatedGalleryImages = await fetchImages('gallery');
      setGalleryPhotos(updatedGalleryImages.length > 0 ? updatedGalleryImages.map(image => image.url) : Array(3).fill(placeholderImage));
      localStorage.setItem('galleryPhotos', JSON.stringify(updatedGalleryImages.length > 0 ? updatedGalleryImages.map(image => image.url) : Array(3).fill(placeholderImage)));
    } catch (error) {
      console.error('Erro ao fazer upload da imagem:', error);
      setUploadError('Erro ao fazer upload da imagem.');
    }
  };

  // Botões customizados de navegação
  const NextArrow = (props) => {
    const { onClick } = props;
    return (
      <button className="custom-slick-next" onClick={onClick}>
        &gt;
      </button>
    );
  };

  const PrevArrow = (props) => {
    const { onClick } = props;
    return (
      <button className="custom-slick-prev" onClick={onClick}>
        &lt;
      </button>
    );
  };

  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const testimonials = [
    { message: 'Excelente escola, meus filhos adoram!', name: 'Maria Silva' },
    { message: 'Ótimos professores e ambiente acolhedor.', name: 'João Souza' },
    { message: 'Recomendo a todos, ensino de qualidade!', name: 'Ana Pereira' },
  ];

  const EducationValueSection = () => (
    <Box
      mb={6}
      mt={10}
      className="education-value-section"
      sx={{
        backgroundColor: '#e0f7fa',
        padding: '40px',
        borderRadius: '8px',
        color: '#004d40',
        position: 'relative',
      }}
    >
      <Typography variant="h4" component="h3" gutterBottom>
        Educação de Valor
      </Typography>
      <Typography variant="body1" component="p">
        Na nossa escola, acreditamos que a educação vai além das salas de aula. Oferecemos uma abordagem holística que promove não apenas o conhecimento acadêmico, mas também o desenvolvimento pessoal e social dos alunos. Com um currículo diversificado e atividades extracurriculares enriquecedoras, nossos alunos são preparados para enfrentar desafios e se destacar em suas futuras carreiras.
      </Typography>
      <Typography variant="body1" component="p">
        Nossa missão é formar cidadãos críticos e criativos, com habilidades para resolver problemas e colaborar em um mundo cada vez mais complexo. Acreditamos na importância de valores como respeito, responsabilidade e empatia, que são integrados ao nosso ensino diário.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        sx={{
          position: 'absolute',
          bottom: '20px',
          right: '20px',
        }}
      >
        Leia Mais
      </Button>
    </Box>
  );

 
  const EducationLevelsSection = () => (
    <Box mb={6} mt={10} className="education-levels-section">
      <Typography variant="h4" component="h3" gutterBottom>
        Níveis de Ensino
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" component="h2">
                Educação Infantil
              </Typography>
              <Typography variant="body2" component="p">
                Oferecemos um ambiente seguro e estimulante para as crianças, com atividades que promovem o desenvolvimento cognitivo e social.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" component="h2">
                Ensino Fundamental
              </Typography>
              <Typography variant="body2" component="p">
                Nosso currículo é projetado para fornecer uma base sólida de conhecimento, com ênfase em habilidades críticas e criativas.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" component="h2">
                Ensino Médio
              </Typography>
              <Typography variant="body2" component="p">
                Preparamos nossos alunos para os desafios do ensino superior e do mercado de trabalho, com um currículo focado em excelência acadêmica.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );

  return (
    <Container sx={{ width: '80%', maxWidth: '90%' }}>
      {/* Seção de Boas-vindas */}
      <Box className="welcome-section" mb={6} mt={10}>
        <div className='fundo-completo'>
          <div className='fundo-boas-vindas'>
            <Typography
             variant="h1"
             component="h1"
             gutterBottom
             sx={{
                fontSize: {
                  xs: '2rem', // Para telas pequenas (xs)
                  sm: '2.5rem', // Para telas médias (sm)
                  md: '3rem', // Para telas grandes (md)
                  lg: '4rem' // Para telas maiores (lg)
                }
              }}
             >
              Bem-vindo à nossa escola!
            </Typography>
          </div>
          <Typography variant="h6" component="p">
            Estamos comprometidos em fornecer uma educação de qualidade e um ambiente acolhedor para todos os alunos.
          </Typography>
        </div>
      </Box>

      {/* Seção de Destaques */}
      <Box mb={6} mt={10}>
        <Typography variant="h4" component="h3" gutterBottom>
          Destaques
        </Typography>
        <Grid container spacing={2}>
          {highlightPhotos.map((photo, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card>
                <CardMedia
                  component="img"
                  alt={`Destaque ${index + 1}`}
                  height="200"
                  image={photo}
                  onClick={() => userType === 'administrator' && openDialog(index, 'highlight')}
                  className="card-highlight"
                  style={{ cursor: 'pointer' }}
                />
                <CardContent>
                  <Typography variant="h6" component="p">

                    {`Destaque ${index + 1}`}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Seção de Galeria */}
      <Box mb={6}>
        <Typography variant="h4" component="h3" gutterBottom>
          Galeria
        </Typography>
        <Slider {...carouselSettings}>
          {galleryPhotos.map((photo, index) => (
            <div key={index}>
              <Card>
                <CardMedia
                  component="img"
                  alt={`Galeria ${index + 1}`}
                  height="200"
                  image={photo}
                  onClick={() => userType === 'administrator' && openDialog(index, 'gallery')}
                  className="card-gallery"
                  style={{ cursor: 'pointer' }}
                />
                <CardContent>
                  <Typography variant="h6" component="p">
                    {`Galeria ${index + 1}`}
                  </Typography>
                </CardContent>
              </Card>
            </div>
          ))}
        </Slider>
      </Box>

      {/* Seção de Depoimentos */}
      <Box mb={6}>
        <Typography
         variant="h4"
         component="h3"
         gutterBottom>
          Depoimentos
        </Typography>
        <Slider {...settings}>
          {testimonials.map((testimonial, index) => (
            <div key={index}>
              <Box className="testimonial">
                <Typography
                 variant="h6"
                 component="p"
                 fontStyle={{ fontStyle: 'italic', fontWeight: 'bold', color: '#6bc4ca' }}
                 >
                  "{testimonial.message}"
                </Typography>
                <Typography
                variant="subtitle1"
                component="p"
                fontStyle={{ fontStyle: 'italic', fontWeight: 'bold', color: '#6bca9e' }}
                >
                  - {testimonial.name}
                </Typography>
              </Box>
            </div>
          ))}
        </Slider>
      </Box>

      {/* Modal de Seleção de Imagem */}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>Selecionar Imagem</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            {dialogImages.map((image, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card>
                  <CardMedia
                    component="img"
                    alt={`Imagem ${index + 1}`}
                    height="200"
                    image={image.url}
                    onClick={() => handleSelectPhoto(image.url)}
                    className="card-dialog"
                    style={{ cursor: 'pointer' }}
                  />
                </Card>
              </Grid>
            ))}
          </Grid>
          <Box mt={2}>
            <Input type="file" onChange={(e) => setUploadFile(e.target.files[0])} />
            {uploadError && <Typography color="error">{uploadError}</Typography>}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleUpload} color="primary">
            Upload
          </Button>
          <Button onClick={() => setDialogOpen(false)} color="secondary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar de Sucesso */}
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={() => setSnackbarOpen(false)}>
        <Alert onClose={() => setSnackbarOpen(false)} severity="success">
          Imagem enviada com sucesso!
        </Alert>
      </Snackbar>
        
        {/* Seções Adicionais */}
        <EducationValueSection />
        <KnowOurSchoolSection />
        <ResultsSection />
        <LocationsSection />
        <EducationLevelsSection />

    </Container>
  );
};

export default Campaigns;
